/** Feed endpoint calls — local, following, events, bazaar, and admin feeds with cursor pagination. */
import type { FeedItem, PaginatedResponse } from '@olimhub/shared'
import type { Language, OfferType } from '@olimhub/shared'
import { apiClient } from '../client'

export interface FeedParams {
  cursor?: string
  language?: Language
  languages?: Language[]
  limit?: number
  tag?: string
  // Nav refactor (Nível 2 chips) — multi-select post type filter for
  // Local/Following. Includes 'action' as a valid value even though it has
  // no backend PostType yet — selecting only it returns an empty feed.
  types?: string[]
}

export interface EventsFeedParams extends FeedParams {
  categoryId?: string
  from?: string
  to?: string
}

export interface BazaarFeedParams extends FeedParams {
  offerType?: OfferType
  categoryId?: string
}

function serializeParams<T extends FeedParams>(params: T): Record<string, unknown> {
  const { languages, types, ...rest } = params
  return {
    ...rest,
    ...(languages?.length ? { languages: languages.join(',') } : {}),
    ...(types?.length ? { types: types.join(',') } : {}),
  }
}

export const feedsApi = {
  getLocal: (params?: FeedParams) =>
    apiClient
      .get<PaginatedResponse<FeedItem>>('/feeds/local', { params: params ? serializeParams(params) : undefined })
      .then((r) => r.data),

  getFollowing: (params?: FeedParams) =>
    apiClient
      .get<PaginatedResponse<FeedItem>>('/feeds/following', { params: params ? serializeParams(params) : undefined })
      .then((r) => r.data),

  getEvents: (params?: EventsFeedParams) =>
    apiClient
      .get<PaginatedResponse<FeedItem>>('/feeds/events', { params: params ? serializeParams(params) : undefined })
      .then((r) => r.data),

  getBazaar: (params?: BazaarFeedParams) =>
    apiClient
      .get<PaginatedResponse<FeedItem>>('/feeds/bazaar', { params: params ? serializeParams(params) : undefined })
      .then((r) => r.data),

  getAdmin: (params?: FeedParams) =>
    apiClient
      .get<PaginatedResponse<FeedItem>>('/feeds/admin', { params: params ? serializeParams(params) : undefined })
      .then((r) => r.data),
}
